import Vue from 'vue';

export const badgeState = Vue.observable({
  state: '',
  updateStatus: null,
});
